import { Injectable } from '@angular/core';

import { Initializable } from './app-init.service';

import { Storage } from '@ionic/storage-angular';
import { Platform } from '@ionic/angular/standalone';
import { File } from '@awesome-cordova-plugins/file/ngx';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@Injectable({
  providedIn: 'root',
})
@EasyDebugDecorator
export class StorageService implements Initializable {
  // Storage Lock n'est présent que sur les pages nécéssitant le Local Storage
  storageLocked = false;
  minDiskSpace = 10000;
  private _storage: Storage | null = null;

  constructor(
    private storage: Storage,
    private file: File,
    private platform: Platform
  ) {
    // console.log('Storage service instanciate');
  }

  private async ensureStorageInitialized(): Promise<Storage> {
    if (!this._storage) {
      this._storage = await this.storage.create();
    }
    return this._storage;
  }

  async init(): Promise<Storage | null> {
    // console.log(`Launching storage init`);
    try {
      // Create the storage instance
      await this.ensureStorageInitialized();
      // console.log('init storage done');
      if (this.platform.is('cordova')) {
        this.storageLocked = !(await this.checkEnougthSpace());
        await this.setStorageLock(this.storageLocked);
      } else {
        await this.setStorageLock(false);
      }
      return this._storage;
    } catch (err) {
      // console.log('init storage failed');
      return null;
    }
  }

  async getDiskSpace() {
    let space = this.platform.is('cordova') ? await this.file.getFreeDiskSpace() : 0;
    if (this.platform.is('cordova') && this.platform.is('ios')) {
      space = space / 1000 || 0;
    } else {
      space = space;
    }

    return space;
  }

  async checkEnougthSpace() {
    let space = this.platform.is('cordova') ? await this.file.getFreeDiskSpace() : 0;
    if (this.platform.is('cordova') && this.platform.is('ios')) {
      space = space / 1000 || 0;
    } else {
      space = space;
    }

    if (space > this.minDiskSpace) {
      return true;
    }
    return false;
  }

  async get(key: string): Promise<any> {
    // console.log('get -> ', key);
    const storage = await this.ensureStorageInitialized();
    return storage.get(key).catch((err) => {
      // console.log('get error -> ', err);
      return null;
    });
  }

  async set(key: string, value: any): Promise<any> {
    // console.log('set -> ', key, value);
    const storage = await this.ensureStorageInitialized();
    return storage.set(key, value).catch((err) => {
      return null;
    });
  }

  async clear(): Promise<any> {
    // console.log('clear');
    const storage = await this.ensureStorageInitialized();
    return storage.clear();
  }

  async remove(key: string): Promise<any> {
    // console.log('removed -> ', key);
    const storage = await this.ensureStorageInitialized();
    return storage.remove(key);
  }

  async keys(): Promise<any> {
    const storage = await this.ensureStorageInitialized();
    return storage.keys();
  }

  async getStorageLock(): Promise<boolean> {
    const storageLock = await this.get('storageLock');
    return storageLock;
  }

  async setStorageLock(isLocked: boolean): Promise<boolean> {
    return await this.set('storageLock', isLocked);
  }
}
